import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { KeycloakAngularModule, KeycloakService } from 'keycloak-angular';
import { environment } from 'src/environments/environment';
import { AuthHttpConfigInterceptor } from './auth-http-config.interceptor';

function initializeKeycloak(keycloak: KeycloakService){
    return () =>
      keycloak.init({
        config: {
          url: environment.authUrl,
          realm: 'enquetes',
          clientId: environment.clientId,
        },
        initOptions: {
          onLoad: 'login-required',
          scope: 'element_de_structure',
          silentCheckSsoRedirectUri:
            window.location.origin + '/assets/silent-check-sso.html'
        },
        enableBearerInterceptor: true,
        bearerPrefix: 'Bearer '
      });
  }

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    HttpClientModule,
    KeycloakAngularModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthHttpConfigInterceptor,
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeKeycloak,
      multi: true,
      deps: [KeycloakService]
    }
  ]
})
export class AuthentificationModule { }
